import Vue from "vue";

export default {
    version: "1.3.1", 
    BASE_URL: 'https://valorinutritie.ro/api',
    BASE_FLAGS_URL: 'https://valorinutritie.ro/assets/images/flags',
    LANGUAGES: ['RO','EN','GR','ES','IT','HU'], // https://flagicons.lipis.dev/flags/4x3/gr.svg
    

    set_token: function(nume, email='', token='', defaultLang='') {
        window.localStorage.setItem("valori-nutritie-token" , token );
        window.localStorage.setItem("valori-nutritie-nume"  , nume  );
        window.localStorage.setItem("valori-nutritie-email" , email );
        window.localStorage.setItem("valori-nutritie-default-language" , defaultLang );
        Vue.http.headers.common["Token"] = token;
    },
 
    get_nume: function () {
        return window.localStorage.getItem("valori-nutritie-nume");
    },

    get_default_language: function () {
        return window.localStorage.getItem("valori-nutritie-default-language");
    },

    get_email: function () {
        return window.localStorage.getItem("valori-nutritie-email");
    },

    get_token: function() {
        return window.localStorage.getItem("valori-nutritie-token");
    },

    is_logged_in: function() {
        var token = this.get_token();
        return token !== "";
    },

    logout: function() {
        this.set_token('');
    },

    is_logged_in: function() {
        var token = this.get_token();
        
        var is_logged = token !== "";
        is_logged = token != null;
        
        return is_logged;
    },

    verify_response: function(response) {
        if (response.body.NotLogged) {
            return false;
        }
        return true;
    },

    verify_login_and_redirect: function(vueInstance) {
        if (!this.is_logged_in()) {
            vueInstance.$router.push("/");
        }
    },
};
